import { forwardRef } from 'react';
import AccountBox from '@mui/icons-material/AccountBox';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AccountTree from '@mui/icons-material/AccountTree';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Bookmarks from '@mui/icons-material/Bookmarks';
import CardMembership from '@mui/icons-material/CardMembership';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Close from '@mui/icons-material/Close';
import Code from '@mui/icons-material/Code';
import ConnectWithoutContact from '@mui/icons-material/ConnectWithoutContact';
import Delete from '@mui/icons-material/Delete';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import ExitToApp from '@mui/icons-material/ExitToApp';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FormatSize from '@mui/icons-material/FormatSize';
import Fullscreen from '@mui/icons-material/Fullscreen';
import FullscreenExit from '@mui/icons-material/FullscreenExit';
import History from '@mui/icons-material/History';
import Home from '@mui/icons-material/Home';
import ImportContacts from '@mui/icons-material/ImportContacts';
import Info from '@mui/icons-material/Info';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LiveHelp from '@mui/icons-material/LiveHelp';
import Lock from '@mui/icons-material/Lock';
import Menu from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MonetizationOn from '@mui/icons-material/MonetizationOn';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import Palette from '@mui/icons-material/Palette';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PlayArrow from '@mui/icons-material/PlayArrow';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import Search from '@mui/icons-material/Search';
import Settings from '@mui/icons-material/Settings';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import VpnKey from '@mui/icons-material/VpnKey';
import Warning from '@mui/icons-material/Warning';
import HelpOutline from '@mui/icons-material/HelpOutline';
import LocalShipping from '@mui/icons-material/LocalShipping';
import Sync from '@mui/icons-material/Sync';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import Assignment from '@mui/icons-material/Assignment';
import Receipt from '@mui/icons-material/Receipt';
import Schedule from '@mui/icons-material/Schedule';
import Cancel from '@mui/icons-material/Cancel';
import DoneAll from '@mui/icons-material/DoneAll';
import Send from '@mui/icons-material/Send';
import MoveToInbox from '@mui/icons-material/MoveToInbox';
import Build from '@mui/icons-material/Build';
import PersonPin from '@mui/icons-material/PersonPin';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import PropTypes from 'prop-types';

const iconMap = {
	account_box: AccountBox,
	account_circle: AccountCircle,
	account_tree: AccountTree,
	arrow_back: ArrowBack,
	arrow_forward: ArrowForward,
	bookmarks: Bookmarks,
	card_membership: CardMembership,
	check_circle: CheckCircle,
	close: Close,
	code: Code,
	connect_without_contact: ConnectWithoutContact,
	delete: Delete,
	error_outline: ErrorOutline,
	exit_to_app: ExitToApp,
	expand_less: ExpandLess,
	expand_more: ExpandMore,
	format_size: FormatSize,
	fullscreen: Fullscreen,
	fullscreen_exit: FullscreenExit,
	history: History,
	home: Home,
	import_contacts: ImportContacts,
	info: Info,
	keyboard_arrow_left: KeyboardArrowLeft,
	keyboard_arrow_right: KeyboardArrowRight,
	live_help: LiveHelp,
	lock: Lock,
	menu: Menu,
	monetization_on: MonetizationOn,
	more_horiz: MoreHoriz,
	palette: Palette,
	person_add: PersonAdd,
	play_arrow: PlayArrow,
	remove_red_eye: RemoveRedEye,
	search: Search,
	settings: Settings,
	shopping_cart: ShoppingCart,
	star: Star,
	star_border: StarBorder,
	verified_user: VerifiedUser,
	vpn_key: VpnKey,
	warning: Warning,
    menu_open: MenuOpenIcon,
	local_shipping: LocalShipping,
	sync: Sync,
	housglass_empty: HourglassEmpty,
	assignment: Assignment,
	receipt: Receipt,
	schedule: Schedule,
	cancel: Cancel,
	done_all: DoneAll,
	send: Send,
	move_to_inbox: MoveToInbox,
	build: Build,
	person_pin: PersonPin,
	check_circle_outline: CheckCircleOutline
};

const FuseSvgIcon = forwardRef(function FuseSvgIcon({ children, className, color, size, sx, ...props }, ref) {
	const iconName = typeof children === 'string' ? children.trim() : '';
	const IconComponent = iconMap[iconName];

	if (!IconComponent) {
		if (iconName) {
			console.warn(`FuseSvgIcon: icon "${iconName}" not found in icon map.`);
		}
		return <HelpOutline ref={ref} className={className} color={color} sx={sx} {...props} />;
	}

	return <IconComponent ref={ref} className={className} color={color} sx={sx} {...props} />;
});

FuseSvgIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.any,
};

FuseSvgIcon.displayName = 'FuseSvgIcon';

export default FuseSvgIcon;
